import { useQuery } from '@tanstack/react-query';
import { toOptions } from '@/shared/lib/options';
import { FilterSelect } from '@/shared/ui/FilterSelect';
import { FormField } from '@/shared/ui/FormField';
import { fetchCities, fetchCountries, fetchRegions } from './api';
import type { ProfileFormApi } from './ProfileInputs';

const REQUIRED = <span className="text-red">*</span>;

/** Country → region → city cascade (legacy used a city autocomplete on the site API). */
export const PlaceFields = ({ form, disabled }: { form: ProfileFormApi; disabled?: boolean }) => {
  const { values, errors, patch } = form;

  const countries = useQuery({ queryKey: ['countries'], queryFn: fetchCountries });
  const regions = useQuery({
    queryKey: ['regions', values.countryId],
    queryFn: () => fetchRegions(values.countryId),
    enabled: Boolean(values.countryId),
  });
  const cities = useQuery({
    queryKey: ['cities', values.regionId],
    queryFn: () => fetchCities(values.regionId),
    enabled: Boolean(values.regionId),
  });

  return (
    <>
      <FormField label={<>Страна {REQUIRED}</>} errors={errors.country_id}>
        <FilterSelect
          options={toOptions(countries.data)}
          value={values.countryId}
          isLoading={countries.isLoading}
          isDisabled={disabled}
          isClearable={false}
          placeholder="Страна"
          onChange={(countryId) => patch({ countryId, regionId: '', cityId: '' }, 'country_id')}
        />
      </FormField>
      <FormField label="Регион" errors={errors.region_id}>
        <FilterSelect
          options={toOptions(regions.data)}
          value={values.regionId}
          isLoading={regions.isFetching}
          isDisabled={disabled || !values.countryId}
          isClearable={false}
          placeholder="Регион"
          onChange={(regionId) => patch({ regionId, cityId: '' }, 'region_id')}
        />
      </FormField>
      <FormField label={<>Город {REQUIRED}</>} errors={errors.city_id}>
        <FilterSelect
          options={toOptions(cities.data)}
          value={values.cityId}
          isLoading={cities.isFetching}
          isDisabled={disabled || !values.regionId}
          isClearable={false}
          placeholder="Город"
          onChange={(cityId) => patch({ cityId }, 'city_id')}
        />
      </FormField>
    </>
  );
};
